import ddt from '@wix/da-ddt';
import { toJsonString } from './utils';
import { AdProviders, ADUNIT_IDS } from './constants';
import NitroAds from './providers/NitroAds';
class DaAds {
    // Special init for SSR where we noop the client only parts
    initSSR(providers) {
        this.init(providers, ()=>Promise.resolve(), []);
        return this;
    }
    // Init for the client
    init(providers, biLogger, activeUnits) {
        ddt.log('ads', 'Init', providers);
        this.biLogger = biLogger;
        this.activeUnits = activeUnits;
        for (const provider of providers){
            const inst = this.factoryProvider(provider);
            if (inst) {
                inst.init(this.biLogger);
                this.activeProviders[provider] = inst;
            }
        }
        this.providersReady = true;
        if (this.registerQueue.length > 0) {
            ddt.log('ads', 'Process Queue');
            this.registerQueue.map((q)=>q());
            this.registerQueue = [];
        }
    }
    registerUnit(provider, unitId, safety, options) {
        // Skip already registered units that have same safety level, happens a lot because SSR
        if (this.activeUnits.includes(this.getAdunitIdent(unitId, safety))) {
            ddt.log('ads', 'Skip ads', provider, unitId, options);
            return;
        }
        ddt.log('ads', 'Register Unit', provider, unitId, options, this);
        if (!this.providersReady) {
            ddt.log('ads', 'Queuing register request', provider, unitId, options);
            let resolve;
            const promisedRegister = new Promise((r)=>{
                resolve = ()=>{
                    r(this.registerUnit(provider, unitId, safety, options));
                };
            });
            this.registerQueue.push(resolve);
            return promisedRegister;
        }
        if (!this.activeProviders[provider]) {
            ddt.alert('ads', 'Tried to register ad for inactive provider', [
                'ads'
            ], {
                provider,
                options
            });
            return;
        }
        if (!ADUNIT_IDS.includes(unitId) && !unitId.includes('-dyn-')) {
            ddt.alert('ads', 'Tried to register unknown adunit', [
                'ads'
            ], {
                provider,
                unitId,
                options
            });
            return;
        }
        try {
            this.activeProviders[provider].registerUnit(unitId, options);
            this.activeUnits.push(this.getAdunitIdent(unitId, safety));
        } catch (e) {
            ddt.alert('ads', 'Error from unit registration', [
                'ads'
            ], {
                provider,
                unitId,
                options,
                e
            });
        }
    }
    killUnit(unitId, safety) {
        for (const key of Object.keys(this.activeProviders)){
            this.activeProviders[key].killUnit(unitId);
        }
        this.activeUnits = this.activeUnits.filter((u)=>u !== this.getAdunitIdent(unitId, safety));
    }
    getSSRAdUnits() {
        let output = `window.__ADUNITS__ = JSON.parse(${toJsonString(this.activeUnits)});\n`;
        for (const key of Object.keys(this.activeProviders)){
            if (this.activeProviders[key].toSSR) {
                output = `${output}${this.activeProviders[key].toSSR()}`;
            }
        }
        return output;
    }
    factoryProvider(provider) {
        switch(provider){
            case AdProviders.Nitro:
                return new NitroAds();
            default:
                ddt.alert('ads', 'Tried to init bad provider', [
                    'ads'
                ], provider);
                return false;
        }
    }
    getAdunitIdent(unitId, safety) {
        return `${unitId}-${safety}`;
    }
    constructor(){
        this.activeProviders = {};
        this.activeUnits = [];
        this.providersReady = false;
        this.registerQueue = [];
    }
}
export default DaAds;
